let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eEyVs")).then(() => parcelRequire('9D6Kx'));